import { render } from "./Spac.vue?vue&type=template&id=f29905a2"
import script from "./Spac.vue?vue&type=script&lang=js"
export * from "./Spac.vue?vue&type=script&lang=js"

import "./Spac.vue?vue&type=style&index=0&id=f29905a2&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__